import React, { useEffect, useState } from "react";
import { getPlatformServicesList, createPlatformService, getProfessionsList } from "../../../services/adminService";

const AdminServices = () => {
    const [services, setServices] = useState([]);
    const [professions, setProfessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [showForm, setShowForm] = useState(false);
    const [newTitle, setNewTitle] = useState("");
    const [selectedProfessions, setSelectedProfessions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [servicesData, professionsData] = await Promise.all([
                    getPlatformServicesList(),
                    getProfessionsList()
                ]);
                setServices(servicesData);
                setProfessions(professionsData);
            } catch (err) {
                setError("Failed to load data");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleCreateService = async () => {
        if (!newTitle.trim()) return;
        try {
            await createPlatformService({
                title: newTitle,
                professions: selectedProfessions,
                is_active: true
            });
            setNewTitle("");
            setSelectedProfessions([]);
            setShowForm(false);
            // refresh list
            const updatedServices = await getPlatformServicesList();
            setServices(updatedServices);
        } catch (err) {
            console.error(err);
            alert("Failed to create service");
        }
    };

    if (loading) return <div className="admin-loading">Loading...</div>;
    if (error) return <div className="admin-error">{error}</div>;

    return (
        <div className="admin-services admin-categories">
            <h2>Platform Services</h2>

            {!showForm && (
                <button
                    className="add-platform"
                    onClick={() => setShowForm(true)}
                >
                    Add Platform Service
                </button>
            )}

            {showForm && (
                <div className="category-create-row form-row" style={{ marginTop: 12, flexDirection: "column", gap: "8px" }}>
                    <input
                        type="text"
                        placeholder="Service Title"
                        value={newTitle}
                        onChange={(e) => setNewTitle(e.target.value)}
                    />
                    <select
                        multiple
                        value={selectedProfessions}
                        onChange={(e) =>
                            setSelectedProfessions(
                                Array.from(e.target.selectedOptions, (opt) => parseInt(opt.value))
                            )
                        }
                    >
                        {professions.map((p) => (
                            <option key={p.id} value={p.id}>
                                {p.name}
                            </option>
                        ))}
                    </select>

                    <div style={{ display: "flex", gap: "10px" }}>
                        <button onClick={handleCreateService}>
                            Save
                        </button>
                        <button onClick={() => setShowForm(false)}>
                            Cancel
                        </button>
                    </div>
                </div>
            )}

            <ul style={{ marginTop: 20 }}>
                {services.length === 0 ? (
                    <p className="admin-empty">No platform services found</p>
                ) : (
                    services.map((service) => (
                        <li key={service.id}>
                            <div className="list-row">
                                <div className="row-main">
                                    <strong>{service.title}</strong>
                                    <div style={{ fontSize: "12px", color: "#777", marginTop: 4 }}>
                                        {service.professions?.length
                                            ? service.professions.join(", ")
                                            : "No professions assigned"}
                                    </div>
                                </div>
                                <div className="row-date">
                                    {service.is_active ? "Active" : "Inactive"}
                                </div>
                            </div>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
};

export default AdminServices;
